import { render, staticRenderFns } from "./SectionMenuSpendings.vue?vue&type=template&id=85777132&scoped=true&"
import script from "./SectionMenuSpendings.vue?vue&type=script&lang=js&"
export * from "./SectionMenuSpendings.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuSpendings.vue?vue&type=style&index=0&id=85777132&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85777132",
  null
  
)

export default component.exports